<template>
    <div id="check">
      <bi-dashboard></bi-dashboard>
    </div>
</template>

<script>

import biDashboard from "./BiDashboard";

export default {
    name: "BiLayout",
    components: {
        biDashboard,
    }
}
</script>

<style>

</style>
